import { ReactNode } from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// ============= RHF Field =============

export interface CheckboxFieldProps<TForm extends FieldValues> {
  name: Path<TForm>;
  control: Control<TForm, any, any>;
  label: string;
  disabled?: boolean;
  /** sx forwarded to FormControlLabel */
  sx?: object;
}

export function CheckboxField<TForm extends FieldValues>({
  name,
  control,
  label,
  disabled,
  sx,
}: CheckboxFieldProps<TForm>): ReactNode {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <MuiCheckbox
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              onBlur={field.onBlur}
              disabled={disabled}
            />
          }
          label={label}
          sx={sx}
        />
      )}
    />
  );
}
